import React from 'react';
import Stack from './stack';
import Modal from 'react-modal';
import axios from 'axios';
import Parser from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import NutritionalInfo from './nutritional-info';
import ProductImage from './components/ProductImage';
import ProductHighlights from './components/ProductHighlights';
import ProductIcons from './components/ProductIcons';
import { Accordion, AccordionItem } from 'react-light-accordion';
import Slider from 'react-slick';
import nourishmentData from './nourishment-data';
import errorHandler from "../../../src/js/snippets/error-handler";

Modal.setAppElement('#quiz-results-root');

class Results extends React.Component {
  state = {
    done: false,
    products: [],
    oneOffSubId: window.subscription_products['kidsOneOffProduct'],
    monthlySubId: window.subscription_products['kidsMonthlyProduct'],
    oneOffPrice: window.subscription_prices['kidsOneOffProduct'],
    monthlyPrice: window.subscription_prices['kidsMonthlyProduct'],
    monthlySellingPlan: window.subscription_products['kidsMonthlySellingPlanId'],
    subscriptionModalOpen: false,
    subscriptionModalContent: '<p>Loading&hellip;</p>',
    addingToCart: false,
    discountText: '',
    localCurrency: 'GBP',
    slideImages: [
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Untitled_design_16.jpg?v=1618390212',
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Untitled_design_14.jpg?v=1618390212',
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Untitled_design_18.jpg?v=1618390212',
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Untitled_design_15.jpg?v=1618390212',
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Untitled_design_13.jpg?v=1618390212',
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Untitled_design_21.jpg?v=1618390212',
    ],
    coating: '',
    coatingMonthly: '',
    loadingProductsError: false,
    numberOfStacks: 28,
    numberOfBoxes: '1 box',
    purchaseText: 'Subscribe | Every 4 weeks',
    purchaseID: window.subscription_products['kidsMonthlyProduct'],
    planType: 'monthly',
    errorTitle: '',
    errorSubtitle: '',
    errorUrl: '',
    errorUrlText: '',
    deliveryText: 'inc. FREE delivery',
  };
  benefits = [];

  componentDidMount() {
    if (this.props.kidsQuizResults !== null) {
      this.getLocale();
      this.getProductData();
      this.getDiscountText();
      this.getErrorText();
      this.getCoatingProducts();
      this.initialPrices();
      setTimeout(() => {
        this.getReviews();
      }, 1000);
    }
  }

  getErrorText() {
    const errorTitle = document.getElementById('errorTitle').textContent;
    const errorSubtitle = document.getElementById('errorSubtitle').textContent;
    const errorUrl = document.getElementById('errorUrl').textContent;
    const errorUrlText = document.getElementById('errorUrlText').textContent;

    this.setState({
      errorTitle: errorTitle,
      errorSubtitle: errorSubtitle,
      errorUrl: errorUrl,
      errorUrlText: errorUrlText
    });
  }

  handleError() {
    this.setState({ loadingProductsError: true });
  }

  getReviews() {
    if (document.getElementById('badge-ribbon')) {
      window.reviewsBadgeRibbon("badge-ribbon", {
        store: "get-nourished.com",
        size: "small",
      });
    }
  }

  initialPrices() {
    let productPrice = this.state.monthlyPrice
      .replace(/\D/g, '')
      .toString();
    let pricePerBox = ((productPrice / 100))
      .toFixed(2)
      .replace(/\D/g, '')
      .toString();
    let pricePerStack = ((productPrice / 100) / 28)
      .toFixed(2)
      .replace(/\D/g, '')
      .toString();
    let oneOffPrice = this.state.oneOffPrice
      .replace(/\D/g, '')
      .toString();

    let subSavings = 100 - ((productPrice / oneOffPrice).toFixed(2) * 100);
    let potentialSavings = `${subSavings}%`;

    let sanitisedPrice = this.formatPrice(productPrice);
    let sanitisedPricePerBox = this.formatPrice(pricePerBox);
    let sanitisedPricePerStack = this.formatPrice(pricePerStack);
    let sanitisedOneOffPrice = this.formatPrice(oneOffPrice);

    this.setState({
      upFrontPlan: '3',
      upFrontDiscount: '25',
      subPrice: sanitisedPrice,
      subPriceOld: sanitisedOneOffPrice,
      pricePerBox: sanitisedPricePerBox,
      pricePerStack: sanitisedPricePerStack,
      oneOffPrice: sanitisedOneOffPrice,
      subSavings: `(save ${subSavings}%)`,
      potentialSavings: potentialSavings
    });
  }

  getCoatingProducts() {
    let customerCoating = '';
    if (this.props.kidsQuizResults.flavour === 'original') {
      customerCoating = `coating-${this.props.kidsQuizResults.coating}`;
    } else {
      customerCoating = `coating-${this.props.kidsQuizResults.flavour}-${this.props.kidsQuizResults.coating}`;
    }

    axios.get(`/products/${customerCoating}.js`)
      .then((response) => {
        const coating = this.oneOffProperties(response.data.variants[0].id, response.data.handle);
        const coatingMonthly = this.monthlyProperties(response.data.variants[0].id, response.data.handle, '', response.data.selling_plan_groups[0].selling_plans[0].id);
        this.setState({ coating, coatingMonthly });
      })
      .catch((error) => {
        console.log(error);
        this.handleError();
      });
  }

  getDiscountText() {
    let dcText = document.getElementById('results-page-discount') !== null ? document.getElementById('results-page-discount').innerHTML : '';

    if (sessionStorage.getItem('DCO')) {
      // Set discount bar text
      dcText = '<span>Get <strong>50%</strong> off all subscription products with code: <strong><span class="discount-code">50OFF</span></strong></span>';
    }

    this.setState({
      discountText: dcText,
    });
  }

  getLocale = () => {
    const defaultCurrencyOptions = JSON.parse(
      document.querySelectorAll('[data-currency-data]')[0].text
    );
    this.setState({ localCurrency: defaultCurrencyOptions.cartCurrency });
  };

  oneOffProperties(variant_id, handle, uuid) {
    const location = 'one-off';
    const data = {
      id: variant_id,
      quantity: 1,
      properties: {
        handle,
        KidsName: this.props.kidsQuizResults.kidsName,
        uuid,
      },
    };
    return data;
  }

  monthlyProperties(variant_id, handle, uuid, sellingPlanId) {
    const data = {
      id: variant_id,
      quantity: 1,
      properties: {
        handle,
        '_KidsName': this.props.kidsQuizResults.kidsName,
        '_uuid': uuid,
      },
      'selling_plan': sellingPlanId
    };
    return data;
  }

  eventProperties(variant_id, handle) {
    const location = window.localStorage.getItem('nourished-event-location');
    const data = {
      id: variant_id,
      quantity: 1,
      properties: {
        handle,
        press_event: location,
        KidsName: this.props.kidsQuizResults.kidsName,
      },
    };
    return data;
  }

  addNourishmentsToCart(subscriptionProductId, subscriptionType, sellingPlanId) {
    const that = this;
    const quizID = this.props.kidsQuizResults.quizID;

    function getCookieValue(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    this.setState({ addingToCart: subscriptionType });
    function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }

    const uuid = uuidv4();

    let itemsForCart = { 'items': [] };

    if (subscriptionType === 'monthly') {
      itemsForCart.items = this.state.products.map((x) =>
        this.monthlyProperties(x.variants[0].id, x.handle, uuid, x.selling_plan_groups[0].selling_plans[0].id)
      );
      let coating = this.state.coatingMonthly;
      coating.properties._uuid = uuid;
      itemsForCart.items.push(coating);
      var subscriptionProduct = this.monthlyProperties(subscriptionProductId);
    } else if (subscriptionType === 'one-off') {
      itemsForCart.items = this.state.products.map((x) =>
        this.oneOffProperties(x.variants[0].id, x.handle, uuid)
      );
      let coating = this.state.coating;
      coating.properties._uuid = uuid;
      itemsForCart.items.push(coating);
      var subscriptionProduct = this.oneOffProperties(subscriptionProductId);
    }

    subscriptionProduct.properties._uuid = uuid;
    subscriptionProduct.properties._quizID = quizID;

    itemsForCart.items.push(
      {
        'id': subscriptionProduct.id,
        'quantity': 1,
        'properties': subscriptionProduct.properties,
        'selling_plan': sellingPlanId,
      }
    );

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemsForCart)
    })
      .then(response => {
        if (response.status != 200) {
          that.setState({ addingToCart: false });
          errorHandler(JSON.stringify(response));
          return;
        }

        if (location === null && subscriptionType != 'one-off') {
          const paramCart =
            '&cart_token=' +
            (document.cookie.match('(^|; )cart=([^;]*)') || 0)[2];
          const paramDomain =
            'myshopify_domain=nourished-official.myshopify.com';
          const paramLinker = '';

          let discountCode = getCookieValue('recharge_discount_code');

          if (discountCode) {
            discountCode = '&discount=' + discountCode;
          }

          inlineCart();
          that.setState({ addingToCart: false });
        } else {
          inlineCart();
          that.setState({ addingToCart: false });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        that.setState({ addingToCart: false });
        errorHandler(JSON.stringify(response));
      });

  }

  getProductData() {
    var that = this;

    axios
      .all(
        this.props.kidsQuizResults.handles.map((handle) => {
          return axios.get(`/products/${handle}.js`);
        })
      )
      .then((responses) => {
        const products = responses.map((response) => response.data);
        that.setState({
          done: true,
          products,
        }, () => {
          this.checkIngredients();
        });
      })
      .catch((error) => {
        console.log(error);
        this.handleError();
      });
  }

  orderOneOff() {
    this.addNourishmentsToCart(this.state.oneOffSubId, 'one-off');
  }

  checkIngredients() {
    const productCount = this.state.products.length;
    for (let index = 0; index < productCount; index++) {
      const element = this.state.products[index].handle;
    }
  }



  changeSelectedProduct = (event) => {
    let changeTo = event.target.value

    let subPrice = ''
    let subPriceOld = ''
    let numberOfBoxes = ''
    let numberOfStacks = ''
    let pricePerStack = ''
    let subSavings = ''
    let purchaseText = ''
    let purchaseID = ''
    let deliveryText = '';

    let frequency = document.getElementById('purchaseType').value

    if (changeTo === 'Monthly' || changeTo === 'OneOff') {

      // Selected PlanType
      document.querySelector('.plan-select .option.active').classList.remove('active');
      document.querySelector(`input#${changeTo} + .option`).classList.add('active');

      document.querySelector('.product__info--display.active').classList.remove('active');
      document.querySelector(`.product__info--display.${changeTo}`).classList.add('active');

      if (changeTo === 'Monthly') {
        this.state.planType = 'monthly';
      } else {
        this.state.planType = 'one-off';
      }

    }

    if (document.querySelector('.results-subscription-option__discount')) {
      if (changeTo == 'Monthly' || changeTo == 4) {
        document.querySelector('.results-subscription-option__discount').classList.add('active');
      } else {
        document.querySelector('.results-subscription-option__discount').classList.remove('active');
      }
    }

    let oneOffPrice = this.state.oneOffPrice
      .replace(/\D/g, '')
      .toString();
    if (changeTo === 'OneOff') {

      // Selected OneOff, get one off details
      numberOfBoxes = '1 box';
      numberOfStacks = 28;
      subPriceOld = '';
      subPrice = oneOffPrice;
      pricePerStack = ((subPrice / 100) / 28)
        .toFixed(2)
        .replace(/\D/g, '')
        .toString();
      subSavings = '';
      purchaseText = 'Add to cart';
      purchaseID = this.state.oneOffSubId;
      deliveryText = '+ £2.99 P&P';
    } else {

      // Selected PlanLength
      if (frequency == '4') {

        // Monthly products
        numberOfBoxes = '1 box';
        numberOfStacks = 28

        // Selected Monthly, get monthly details
        subPriceOld = oneOffPrice;
        subPrice = this.state.monthlyPrice
          .replace(/\D/g, '')
          .toString();
        pricePerStack = ((subPrice / 100) / 28)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        subSavings = 100 - ((subPrice / oneOffPrice).toFixed(2) * 100);
        subSavings = `(save ${subSavings}%)`;
        purchaseText = 'Subscribe | Every 4 weeks';
        purchaseID = this.state.monthlySubId;
        deliveryText = 'inc. FREE delivery';

      } else if (frequency == '12') {

        numberOfBoxes = '3 boxes';
        numberOfStacks = 84;

        // Selected 3 Month, get 3 month details
        subPriceOld = ((oneOffPrice / 100) * 3)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        subPrice = this.state.threeBoxBundlePrice
          .replace(/\D/g, '')
          .toString();
        pricePerStack = ((subPrice / 100) / 3 / 28)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        subSavings = 100 - ((subPrice / (oneOffPrice * 3)).toFixed(2) * 100);
        subSavings = `(save ${subSavings}%)`;
        purchaseText = 'Subscribe | Every 12 weeks';
        purchaseID = this.state.threeBoxBundleSubId;
        deliveryText = 'inc. FREE delivery';

      } else if (frequency == '52') {

        numberOfBoxes = '1 box';
        numberOfStacks = 28

        // Selected Annual, get annual details 
        subPriceOld = ((oneOffPrice / 100) * 13)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        subPrice = this.state.annualPrice
          .replace(/\D/g, '')
          .toString();
        pricePerStack = ((subPrice / 100) / 13 / 28)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        // subSavings = 100 - ((subPrice / (oneOffPrice*13)).toFixed(2) * 100);
        subSavings = 30;
        subSavings = `(save ${subSavings}%)`;
        purchaseText = 'Subscribe | Pay Annually';
        purchaseID = this.state.annualSubId;
        deliveryText = 'inc. FREE delivery';

      }
    }

    let sanitisedSubPrice = this.formatPrice(subPrice);
    let sanitisedPricePerStack = this.formatPrice(pricePerStack);

    let sanitisedSubPriceOld = '';
    if (changeTo === 'OneOff') {
      sanitisedSubPriceOld = '';
    } else {
      sanitisedSubPriceOld = this.formatPrice(subPriceOld);
    }

    this.setState({
      subPrice: sanitisedSubPrice,
      subPriceOld: sanitisedSubPriceOld,
      numberOfBoxes: numberOfBoxes,
      numberOfStacks: numberOfStacks,
      pricePerStack: sanitisedPricePerStack,
      subSavings: subSavings,
      purchaseText: purchaseText,
      purchaseID: purchaseID,
      deliveryText: deliveryText
    })
  }

  addToCart = (event) => {
    let id = event.target.dataset.productid;
    let subscriptionType = ''
    let sellingPlanId = ''

    if (this.state.planType == 'one-off') {
      subscriptionType = 'one-off'
    } else {
      subscriptionType = 'monthly'
      sellingPlanId = this.state.monthlySellingPlan
    }

    this.addNourishmentsToCart(id, subscriptionType, sellingPlanId);
  }

  formatPrice(p) {
    // const shopCurrency = window.Shopify.currency.active;
    let formattedPrice = '';
    let currencySymbol = '£';
    let currencySeparator = '.';

    if (p.slice(-2) === '00' && p.length > 3) {
      formattedPrice = currencySymbol + p.substring(0, p.length - 2);
    } else {
      formattedPrice = currencySymbol + p.substring(0, p.length - 2) + currencySeparator + p.substring(p.length - 2, p.length);
    }

    return formattedPrice;
  }

  render() {
    const sliderSettings = {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
    };
    if (this.state.done) {
      return (
        <div className="quiz-results-page">
          <div className="results-top-section">
            <div className="container">
              <div class="cont">
                <div className="quiz-stack">
                  {this.state.done ? (
                    <Stack
                      results={this.props.kidsQuizResults}
                      products={this.state.products}
                    />
                  ) : (
                    ''
                  )}
                  <div className="result-stack--buttons">
                    <div className="quiz-subscribe-cta">
                      <div className="quiz-subscribe-cta__buttons">
                        <div className="results-subscription results-subscription--kids">
                          {window.localStorage.getItem(
                            'nourished-event-location'
                          ) ? (
                            <button
                              type="button"
                              disabled={this.state.addingToCart}
                              className="button button-light quiz-button-choose"
                              onClick={this.orderOneOff.bind(this)}
                            >
                              {this.state.addingToCart === 'one-off' ? (
                                <FontAwesomeIcon icon={faSpinner} spin />
                              ) : (
                                ''
                              )}{' '}
                              Buy
                            </button>
                          ) : (
                            <>
                              <div className={`product__info--options ${this.state.addingToCart ? 'disabled' : ''}`}>
                                <label for="Monthly" className="plan-select subscription">
                                  <input id="Monthly" type="radio" name="planType" value="Monthly" checked="checked" onChange={this.changeSelectedProduct} />
                                  <div className="option active">
                                    <div>Subscribe &amp; Save</div>
                                  </div>
                                </label>
                                <label for="OneOff" className="plan-select oneOff">
                                  <input id="OneOff" type="radio" name="planType" value="OneOff" onChange={this.changeSelectedProduct} />
                                  <div className="option">
                                    <div>One Time</div>
                                  </div>
                                </label>

                                <div className="product__info--options-content">
                                  <div className="option-info styled">
                                    <div className="product__info--display Monthly active">
                                      <label for="purchase-type" className="select-label">Delivered every 4 weeks</label>
                                      <div className="orderFrequency">
                                        <div className="select-container" style={{ display: 'none' }}>
                                          <select name="purchase-type" id="purchaseType" defaultValue={4} onChange={this.changeSelectedProduct}>
                                            <option value="4">Every 4 weeks - Most Popular</option>
                                            {/* <option value="12">Every 12 weeks - 3 boxes at a time</option>
                                            <option value="52">Pay Annually - Delivered every 4 weeks</option>                 */}
                                          </select>
                                        </div>
                                      </div>
                                      <p>Cancel anytime | Fully edit your subscription</p>
                                    </div>
                                    <div className="product__info--display OneOff">
                                      <p><strong>You could save <span className="savings">{this.state.potentialSavings}</span> with a subscription</strong> You've selected a one-time purchase. Why not switch to our fully flexible subscription and save {this.state.potentialSavings} on each box of Nourished?</p>
                                    </div>
                                    <div className="pricing">
                                      <div className="pricing-left">
                                        <span className="subscription-priceOld" id="subPriceOld">{this.state.subPriceOld}</span>
                                        <span className="subscription-price" id="subPrice">{this.state.subPrice}</span>
                                        <span className="subscription-savings" id="subSavings">{this.state.subSavings}</span>
                                        <span className="deliveryText">{this.state.deliveryText}</span>
                                      </div>
                                      <div className="pricing-right">
                                        <span className="small">{this.state.numberOfBoxes} | {this.state.numberOfStacks} gummies</span>
                                        <span className="pricePerBar subscriptionPerBar"><span id="pricePerDay">{this.state.pricePerStack}</span> per day</span>
                                      </div>
                                    </div>
                                    {this.state.discountText ?
                                      <>
                                        <div className="results-subscription-option__discount active">
                                          {Parser(this.state.discountText)}
                                        </div>
                                      </> : ''
                                    }
                                  </div>
                                </div>
                              </div>
                              <button
                                type="button"
                                id="purchaseAddToCart"
                                data-productid={this.state.purchaseID}
                                className={`btn btn-primary ${this.state.addingToCart ? 'loading' : ''}`}
                                onClick={this.addToCart}>{this.state.purchaseText}</button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="new-results-stacks quiz-stack-layers">
                  <div id="aboutYourStack" className="results-stacks quiz-nourishments">
                    <h2>About your stack</h2>
                    <Accordion atomic="true" className="results-nourishment">
                      {this.state.products.map((product, index) => {
                        return (
                          <div className="accordion-item__wrapper" onClick={this.accordionWrapper}>
                            <img className="accordion-item__image"
                              src={window.stack_image_urls[product.handle]}
                              style={{ 'zIndex': (10 - index) }}
                            />
                            <AccordionItem title={product.title}>
                              <div>
                                <ProductHighlights product={product.handle} />
                                {product.handle === '5-htp' ?
                                  <p className="product-highlights__support-text">5-HTP can have some adverse reactions in people who are taking certain kinds of medications for depression.We highly recommend you speak to your doctor before starting any supplement regime.</p>
                                  : ''}
                                {product.handle === 'iodine' ?
                                  <p className="product-highlights__support-text">Iodine can have some adverse reactions in people who are taking certain kinds of medications for high blood pressure, anti-thyroid and potassium-sparing diuretics. We highly recommend you speak to your doctor before starting any supplement regime.</p>
                                  : ''}
                              </div>
                            </AccordionItem>
                          </div>
                        );
                      })}
                      <AccordionItem title={'Nutritional Info'}>
                        <NutritionalInfo products={this.props.kidsQuizResults.allHandles} />
                        <p>
                          Maltitol Syrup, Erythritol, Pectin, Potassium Citrate,
                          Citric Acid, Maltodextrin,{' '}
                          {this.props.kidsQuizResults.allHandles.map(
                            (handle) => {
                              return `${nourishmentData[handle].sanitisedName}, `;
                            }
                          )}{' '}
                          Malic Acid, Natural Colour, Natural Flavour.
                        </p>
                        <p>Food supplements must not be used to substitute a healthy diet.</p>
                      </AccordionItem>
                    </Accordion>
                    <div id="badge-ribbon"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="page-quiz__nourishments">
            <div className="container">
              <div class="cont">
                <div className="nourishments__column product-page-carousel">
                  <Slider {...sliderSettings}>
                    {this.state.slideImages.map((imageSrc) => (
                      <div className="ease">
                        <img src={imageSrc} />
                      </div>
                    ))}
                  </Slider>
                </div>

                <div className="nourishments__column quiz-nourishments">
                  <h2 className="heading heading--medium">In each stack.</h2>
                  {this.state.done ? (
                    <>
                      <Accordion atomic="true" className="results-nourishment">
                        {this.state.products.map((product, index) => {
                          return (
                            <AccordionItem title={product.title}>
                              <ProductImage product={product.handle} />
                              <div>
                                <ProductHighlights product={product.handle} />
                                <ProductIcons product={product.handle} />
                              </div>
                            </AccordionItem>
                          );
                        })}
                        <AccordionItem title={'Nutritional Info'}>
                          <NutritionalInfo products={this.props.kidsQuizResults.allHandles} />
                          <p>
                            Maltitol Syrup, Erythritol, Pectin, Potassium Citrate,
                            Citric Acid, Maltodextrin,{' '}
                            {this.props.kidsQuizResults.allHandles.map(
                              (handle) => {
                                return `${nourishmentData[handle].sanitisedName}, `;
                              }
                            )}{' '}
                            Malic Acid, Natural Colour, Natural Flavour.
                          </p>
                          <p>Food supplements must not be used to substitute a healthy diet.</p>
                        </AccordionItem>
                      </Accordion>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.loadingProductsError) {
      return (
        <div className="error-container">
          <h1>{this.state.errorTitle}</h1>
          <p className="subtitle">{this.state.errorSubtitle}</p>
          <a href='/pages/kids-quiz' className="button button-light quiz-button-choose">{this.state.errorUrlText}</a>
        </div>
      )
    } else if (this.props.kidsQuizResults === null) {
      return (
        <div className="error-container">
          <h1>Oops! We're struggling to find your results.</h1>
          <p className="subtitle">Take our quiz to see your bespoke vitamin blend!</p>
          <a href='/pages/kids-quiz' className="button button-light quiz-button-choose">Take the Quiz</a>
        </div>
      )
    } else {
      return (
        <div className="container">
          <p className="text-center">Loading&hellip;</p>
        </div>
      );
    }
  }
}

export default Results;
